import { render } from "./UserProfilePhotoEditor.vue?vue&type=template&id=11e8e450&scoped=true"
import script from "./UserProfilePhotoEditor.vue?vue&type=script&lang=js"
export * from "./UserProfilePhotoEditor.vue?vue&type=script&lang=js"

import "./UserProfilePhotoEditor.vue?vue&type=style&index=0&id=11e8e450&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e8e450"]])

export default __exports__